
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { UnavailableForLegalReasonsPage } from '@/components/Pages/Errors/UnavailableForLegalReasonsPage';
import { InsightExecSumPage } from '@/components/Pages/Insights/InsightExecSumPage';
import { getAnalyticsData, getBaseAnalytics } from '@/components/Templates/InfiniteScrollPage/InfiniteScrollPage';
import { BaseAppContextContainer } from '@/contexts/AppContext/AppContextContainer';
import type { AppContextProps } from '@/contexts/AppContext/AppContextServer';
import { getAppContextServerSideProps } from '@/contexts/AppContext/AppContextServer';
import { ContentType } from '@/interfaces';
import type { ComponentProps } from 'react';
export const getPublicServerSideProps = async ({ query, api, res }: AppContextProps) => {
    const data = await api.get({
        path: '/public/insights/[ID]',
        query: {
            language: query?.language && query.language.toString(),
        },
        replacements: { id: query.id?.toString() },
    });
    if (data !== null) {
        const insight = data?.insight;
        return {
            type: ContentType.insight,
            title: insight.title,
            publishDate: insight.displayDate,
            description: insight.summary,
            author: insight.author,
            image: insight.image,
            tags: insight.tags,
        };
    }
    res.statusCode = 404;
};
const getServerSideProps = getAppContextServerSideProps(async ({ query, api, res }) => {
    const apiQuery: any = {};
    if (query?.language) {
        apiQuery.language = query.language;
    }
    try {
        const data = await api.get({
            path: '/insights/[ID]',
            replacements: { id: query.id as string },
            query: apiQuery,
        });
        if (data !== null) {
            api.post({
                path: '/users/content_view',
                body: { contentId: data.insight.id, contentType: ContentType.insight },
            }).catch(() => { });
            return {
                props: {
                    ...data,
                    analyticsMetadata: getAnalyticsData(ContentType.insight, data.insight.id),
                },
            };
        }
    }
    catch (e) {
        const acceptableHttpErrors = [451];
        if (e.hasOwnProperty('response') && acceptableHttpErrors.includes(e?.response?.status)) {
            res.statusCode = e.response.status;
            return {
                props: {
                    analyticsMetadata: getBaseAnalytics(ContentType.insight),
                    responseCode: e.response.status,
                },
            };
        }
        throw e;
    }
    return { notFound: true };
}, getPublicServerSideProps);
export default class extends BaseAppContextContainer<ComponentProps<typeof InsightExecSumPage> & {
    responseCode?: number;
}> {
    public render() {
        if (this.props?.responseCode === 451) {
            return <UnavailableForLegalReasonsPage />;
        }
        return <InsightExecSumPage {...this.props}/>;
    }
}

    async function __Next_Translate__getServerSideProps__1a17845b30b__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/insights/[id]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a17845b30b__ as getServerSideProps }
  